import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatMenu, MatMenuItem,MatMenuTrigger } from '@angular/material/menu';

import { CustomButtonComponent } from '../message-controls/custom-button/custom-button.component';

@Component({
    selector: 'app-prompt-hints-menu',
    templateUrl: './prompt-hints-menu.component.html',
    styleUrls: ['./prompt-hints-menu.component.scss'],
    standalone: true,
    imports: [CustomButtonComponent, MatMenuTrigger, MatMenu, MatMenuItem]
})
export class PromptHintsMenuComponent {
  @Input() promptHints: string[] = [];
  @Output() hintSelected = new EventEmitter<string>();
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;

  isMenuOpen = false;

  updateMessage(hint: string) {
    this.hintSelected.emit(hint);
  }

  onMenuOpened() {
    this.isMenuOpen = true;
  }

  onMenuClosed() {
    this.isMenuOpen = false;
  }
}
